<template>
  <div>
    <h4>數學</h4>
    <p>
      <b>每年二月底</b>舉辦3-5年級高僑盃競試，高僑盃的成績可作為分班依據。如果沒有參加到高僑盃競試，或對高僑盃成績不滿意，約兩週後會舉辦團體甄試（請密切注意！）兩者成績擇優入班。
      <b>無論成績如何都至少可參加3-5年級數學班、6年級私中班課程。</b>而在班就讀期間，複習考表現優良同學也可以再往上提升到更高難度的課程唷！
    </p>
    <h5>3-5年級</h5>
    <p>
      國小3-5年級課程分為三種不同難度，數學班、資優班以及特訓班，難度由簡而深。
    </p>
    <ul>
      <li>
        數學班－目標考取各大私立國中或加強數學，學習內容較學校課程深且廣，及早開始準備絕對能擁有考上理想私中的實力！
      </li>
      <br />
      <li>
        資優班（甄試入班）－課程難度較數學班深入，目標為考取理想私立國中、公立國中資優班或加強數學等，為日後打好基礎，未來成績可蒸蒸日上！
      </li>
      <br />
      <li>
        特訓班（甄試入班）－目標為考取私立國中爭取獎學金、考取公立國中資優班或加強數學實力為日後準備，學習內容比資優班更深入，未來6年級可望接續就讀特訓班或菁英班。
      </li>
    </ul>
    <h5>6年級</h5>
    <p>（教學難度由簡而深）</p>
    <ul>
      <li>
        私中班－高僑私中班學生有超過一半能考取衛道、七成以上能考取明道，且全數能考上私立學校就讀。
      </li>
      <br />
      <li>
        資優班（甄試入班）－資優班學生歷年約六至七成學生能考取衛道，八成學生能考取明道。
      </li>
      <br />
      <li>
        特訓班（甄試入班）－特訓班學生歷年約八成考取衛道，且幾乎都能考取明道。
      </li>
      <br />
      <li>
        菁英班（甄試入班）－高僑菁英班同學程度極優，一般能全數考取衛道、曉明、明道國中，更有多數同學能進入各私校前十名榜單以及獲得各校獎學金。學習的難度足夠未來希望考上衛道科學班、明道拔尖班的學生。
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
